import React, { useMemo } from 'react'
import { Container } from 'shared/components'
import CreateForm from './CreateForm'
import { useFormik } from 'formik'
import { GiftConditionCreateModel } from 'types/gift-conditions'
import * as yup from 'yup'
import useToastify from 'hooks/useToastify'
import { useNavigate } from 'react-router-dom'
import * as urls from 'constans/urls'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { giftconditionApis, productApis } from 'api'
import { GIFT_CONDITIONS, PRODUCTS } from 'constans/queryKeys'
import { SelectOption } from 'shared/components/SelectField'
import { MAX_TEM_QUANTITY, INVALID_NUMBER } from 'constans/gift-conditions'
import { theme } from 'Providers/ThemeProvider'

const validationSchema = yup.object({
  productCode: yup.string().required('Vui lòng chọn sản phẩm!'),
  temQuantity: yup
    .number()
    .required('Vui lòng nhập số lượng tem!')
    .typeError(INVALID_NUMBER)
    .min(1, 'Số lượng tem phải lớn hơn 0')
    .max(MAX_TEM_QUANTITY, `Số lượng tem không vượt quá ${MAX_TEM_QUANTITY}`),
  createdUser: yup.string().required('Vui lòng nhập tên người tạo!'),
})

const CreateCondition = () => {
  const { showSuccess, showError } = useToastify()
  const navigate = useNavigate()
  const onBack = () => {
    navigate(`/${urls.GIFT_CONDITION_URLS.LIST}`)
  }
  const queryClient = useQueryClient()
  const { data: productData } = useQuery({
    queryKey: [PRODUCTS],
    queryFn: () =>
      productApis.getList({
        pageIndex: 0,
        pageSize: 1000,
        allowChangeTem: 1,
      }),
  })

  const productOptions: Array<SelectOption<string>> = useMemo(() => {
    if (!productData || !productData.Result) return []
    return productData?.Result?.map(p => ({
      label: p.ProductName,
      value: `${p.ProductCode}`,
      key: p.ProductId,
    }))
  }, [productData])

  const { mutate, isPending } = useMutation({
    mutationFn: (val: GiftConditionCreateModel) =>
      giftconditionApis.create(val),
    onSuccess: d => {
      if (d?.ErrorCode === 0) {
        showSuccess('Tạo điều kiện nhận quà thành công')
        queryClient.invalidateQueries({
          queryKey: [GIFT_CONDITIONS],
        })
        onBack()
      } else if (d?.ErrorCode === 1 && !!d?.ErrorMessage) {
        showError(d.ErrorMessage)
      } else {
        showError('Đã xảy ra lỗi, vui lòng thử lại!')
      }
    },
    onError: e => {
      showError('Đã xảy ra lỗi, vui lòng thử lại!')
    },
  })

  const onSubmit = (val: GiftConditionCreateModel) => {
    mutate(val)
  }
  const formik = useFormik<GiftConditionCreateModel>({
    initialValues: {
      productCode: '',
      productName: '',
      temQuantity: undefined,
      createdUser: '',
    },
    validationSchema,
    onSubmit,
  })
  return (
    <Container
      sx={{
        width: '50%',
        [theme.breakpoints.down(1448)]: {
          width: '80%',
        },
      }}
      title="Tạo điều kiện nhận quà"
    >
      <CreateForm
        productOptions={productOptions || []}
        onBack={onBack}
        isSubmiting={isPending}
        formik={formik}
      />
    </Container>
  )
}

export default CreateCondition
